// Single source of truth for config names.
export const Config = {
  test: 'test',
  requestMagicLinkForm: 'REQUEST_MAGIC_LINK_FORM',
  enableCarrierArchivedShipments: 'ENABLE_CARRIER_ARCHIVED_SHIPMENTS',
  enableCarrierShipmentListChat: 'ENABLE_CARRIER_SHIPMENT_LIST_CHAT',
  enableCheckInOutEdit: 'ENABLE_CHECK_IN_OUT_EDIT',
  enableFlexibleReferenceNumber: 'ENABLE_FLEXIBLE_REFERENCE_NUMBER',
  enablePneumaticHopperEquipmentType: 'ENABLE_PNEUMATIC_HOPPER_EQUIPMENT_TYPE',
} as const

export type ConfigName = (typeof Config)[keyof typeof Config]
